import React, { useState } from "react";

const twitteContext = React.createContext({
  twittes: [],
  twitte: "",
  Iindex: "",
  updater: "",
  setTwittes: (state) => {},
  setTwitte: (state) => {},
  setIindex: (state) => {},
  findComments: (key) => {},
  setUpdater: (state) => {},
});

export default twitteContext;

export const TwitteContextProvider = ({ children }) => {
  const [twittes, setTwittes] = useState([]);
  const [twitte, setTwitte] = useState(null);
  const [counter, setCounter] = useState(3);
  const [updater, setUpdater] = useState(false);
  // const findComments = (key = -1) => {
  //   let theTwitte = twitte;
  //   if (key != -1) theTwitte = twittes.find((val) => val.key === key);
  //   return twittes.filter(
  //     (value) =>
  //       theTwitte.comments.find((val) => val.value === value.key) &&
  //       value.isComment
  //   );
  // };
  return (
    <twitteContext.Provider
      value={{
        twittes,
        twitte,
        counter,
        updater,
        setTwittes,
        setTwitte,
        // findComments,
        setCounter,
        setUpdater,
      }}
    >
      {children}
    </twitteContext.Provider>
  );
};
